export default __webpack_public_path__ + "static/media/codaly_design.90a73a97.png";